import { VStack, HStack, Image, Text, useToken, Box } from "@chakra-ui/react";
import { GradientDivider } from "./GradientDivider";
import {
  interpretColorTags,
  interpretBoldTags,
} from "../../../utils/processPaywallText";
import { ValuePropType } from "../types";

export function ValueProps({
  valueProps,
  vpTitle,
}: {
  valueProps: ValuePropType[];
  vpTitle: string;
}) {
  const [blazeColor] = useToken("colors", ["blaze.blaze"]);
  const titleText = interpretColorTags(vpTitle, blazeColor);
  return (
    <VStack gap={8} px={6} py={8} background="transparent.black.40">
      <Text
        variant="paymentTitle"
        whiteSpace="pre-wrap"
        dangerouslySetInnerHTML={{ __html: titleText }}
      />
      <VStack>
        {valueProps.map((valueProp, i) => (
          <VStack key={i} alignItems="flex-start" width="100%">
            <ValueProp valueProp={valueProp} />
            {i < valueProps.length - 1 && (
              <Box my="18px" width="100%">
                <GradientDivider />
              </Box>
            )}
          </VStack>
        ))}
      </VStack>
    </VStack>
  );
}

export function ValueProp({ valueProp }: { valueProp: ValuePropType }) {
  const bodyText = interpretBoldTags(valueProp.body, 700, "neutral.200");
  return (
    <HStack gap={5} alignItems="start">
      <Image src={valueProp.icon_url} boxSize={12} alt={valueProp.header} />
      <VStack alignItems="start">
        <Text variant="paymentValuePropHeader">{valueProp.header}</Text>
        <Text
          variant="paymentValuePropBody"
          dangerouslySetInnerHTML={{ __html: bodyText }}
        />
      </VStack>
    </HStack>
  );
}
